module.exports = __webpack_public_path__ + "img/ic_wuxingxi@3x.e05d4df1.png";